import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ButtonList, DropdownButton, DropdownButtonContext, FlexBox, Text, } from '@dixa/lib-shared-habla';
import { analytics } from 'app/utils/segment';
import { searchActions } from 'app/views/layout/views/search/search.actions';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppSelector } from 'utils/redux/useAppSelector';
import { useAppPathParams } from 'utils/url/useAppPathParams';
import { convertSortObjectToString, convertSortStringToObject, } from '../../../../utils/sort/convertSort';
export const sortOptions = [
    {
        value: '',
        label: 'Relevance',
        tabs: ['conversations', 'notes'],
    },
    {
        value: 'updated_at:desc',
        label: 'Activity: Newest first',
        tabs: ['conversations'],
    },
    {
        value: 'updated_at:asc',
        label: 'Activity: Oldest first',
        tabs: ['conversations'],
    },
    {
        value: 'created_at:desc',
        label: 'Created: Newest first',
        tabs: ['conversations', 'notes'],
    },
    {
        value: 'created_at:asc',
        label: 'Created: Oldest first',
        tabs: ['conversations', 'notes'],
    },
    {
        value: 'last_message_created_at:desc',
        label: 'Last message: Newest first',
        tabs: ['conversations'],
    },
    {
        value: 'last_message_created_at:asc',
        label: 'Last message: Oldest first',
        tabs: ['conversations'],
    },
];
/**
 * Represents a component that is used to select a sorting option from a
 * dropdown
 */
export const SearchResultsSort = ({ className, }) => {
    const { params } = useAppSelector((state) => state.search);
    const dispatch = useAppDispatch();
    const { tab } = useAppPathParams('/search/:tab');
    if (tab === 'contacts')
        return null;
    const value = convertSortObjectToString(params.sort);
    const selectedOption = sortOptions.find((option) => value === option.value);
    function handleToggleSortBy(value) {
        const nextParams = {
            sort: convertSortStringToObject(value),
            page: 1,
        };
        dispatch(searchActions.params.update(nextParams));
        analytics.searchSortingUpdated({
            tab: tab,
            type: !value ? 'relevance' : value,
        });
    }
    return (_jsxs(FlexBox, Object.assign({ className: className, alignItems: "center" }, { children: [_jsx(Text.Paragraph, Object.assign({ variant: "3", subdued: true }, { children: "Sort by:" })), _jsx(DropdownButton, Object.assign({ buttonProps: { variant: 'tertiary' }, dropdown: _jsx(DropdownButtonContext.Consumer, { children: ({ toggleDropdown }) => (_jsx(ButtonList, { children: sortOptions
                            .filter((option) => option.tabs.includes(tab))
                            .map((option) => (_jsx(ButtonList.Item, Object.assign({ isSelected: value === option.value, onClick: () => {
                                if (value === option.value)
                                    return;
                                toggleDropdown();
                                handleToggleSortBy(option.value);
                            } }, { children: option.label }), option.value))) })) }), fixed: true }, { children: selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label }))] })));
};
